export const getSuperbillTasksData = state => state.superbillTasks.all;
export const getSuperbillTaskData = state => state.superbillTasks.superbillTask;
export const superbillTasksIsFetching = state => state.superbillTasks.loading.all;
export const superbillTaskIsFetching = state => state.superbillTasks.loading.superbillTask;